import React from "react";
import { Student } from "@/types/tutor";
import StudentCard from "./StudentCard";

interface StudentListProps {
  students: Student[];
  classroomId: string;
}

const StudentList: React.FC<StudentListProps> = ({ students }) => {
  return (
    <div>
      {students.length === 0 ? (
        <p className="et-group-students-empty">No students enrolled</p>
      ) : (
        <div className="flex flex-wrap gap-x-8 gap-y-4">
          {students.map((student) => (
            <StudentCard key={student.id} student={student} />
          ))}
        </div>
      )}
    </div>
  );
};

export default StudentList;
